import { c as _c } from "react/compiler-runtime";
import FeaturedCard from "@/components/server/FeaturedCard/FeaturedCard";
import { CardGeneral } from "../../terra/component/CardGeneral/CardGeneral";
export interface blogPanelProps {
  cards: any;
  activeTab: number; // The current active tab
  loadMoreText?: string; // Text for the load more button
  loadMoreHandler?: () => void; // Function to load more cards
  showLoadMore?: boolean;
  imageType?: "asImage" | "asBackground"; // Type of image display
  lang?: string;
  noResultsText?: string;
}
export const BlogPanel = t0 => {
  const $ = _c(16);
  const {
    cards,
    loadMoreText: t1,
    loadMoreHandler,
    showLoadMore: t2,
    imageType: t3,
    noResultsText: t4
  } = t0;
  const loadMoreText = t1 === undefined ? "Load More Results" : t1;
  const showLoadMore = t2 === undefined ? false : t2;
  t3 === undefined ? "asImage" : t3;
  const noResultsText = t4 === undefined ? "No Results" : t4;
  if (!cards) {
    return null;
  }
  if (cards?.length === 0) {
    let t5;
    if ($[0] !== noResultsText) {
      t5 = <p>{noResultsText}</p>;
      $[0] = noResultsText;
      $[1] = t5;
    } else {
      t5 = $[1];
    }
    return t5;
  }
  const [featuredCard] = cards;
  let t5;
  if ($[2] !== featuredCard) {
    t5 = featuredCard && <FeaturedCard {...featuredCard} truncate={true} truncateLength={135} imageType="asBackground" />;
    $[2] = featuredCard;
    $[3] = t5;
  } else {
    t5 = $[3];
  }
  let t6;
  if ($[4] !== cards) {
    t6 = cards?.map(_temp);
    $[4] = cards;
    $[5] = t6;
  } else {
    t6 = $[5];
  }
  let t7;
  if ($[6] !== t6) {
    t7 = <div className="grid grid-cols-1 sm:grid-cols-2 xl:grid-cols-3 gap-5 mb-[30px] sm:mb-[50px] xl:mb-[90px] [&_.t2-card]:max-sm:mx-auto items-stretch">{t6}</div>;
    $[6] = t6;
    $[7] = t7;
  } else {
    t7 = $[7];
  }
  let t8;
  if ($[8] !== loadMoreHandler || $[9] !== loadMoreText || $[10] !== showLoadMore) {
    t8 = showLoadMore && <div className="flex justify-center items-center py-[60px]"><button className="t2-button t2-button--medium t2-button--primary " onClick={loadMoreHandler}>{loadMoreText}</button></div>;
    $[8] = loadMoreHandler;
    $[9] = loadMoreText;
    $[10] = showLoadMore;
    $[11] = t8;
  } else {
    t8 = $[11];
  }
  let t9;
  if ($[12] !== t5 || $[13] !== t7 || $[14] !== t8) {
    t9 = <div className="t2-resource-grid__blog-cards">{t5}{t7}{t8}</div>;
    $[12] = t5;
    $[13] = t7;
    $[14] = t8;
    $[15] = t9;
  } else {
    t9 = $[15];
  }
  return t9;
};
function _temp(card, index) {
  return <div key={`blog-card-${index}`} className={`h-full ${index === 0 ? "xl:hidden" : ""}`}><CardGeneral cardType="bound" image={card?.image} imageType="asImage" eyebrowIcon={card?.eyebrowIcon} eyebrow={card?.eyebrow} header={card?.title} description={card?.description} button={{
      label: card?.buttonLabel || "Read More",
      destination: card?.slug,
      linkType: "text",
      isIcon: true
    }} truncate={true} truncateLength={135} inheritedClasses="h-full !mb-0" /></div>;
}